import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addExtraAdmin, deleteExtraAdmin, updateExtraAdmin, getExtraAdminById, getAllExtraAdmin } from '../../../redux/actions/ExtraAdmin.action';

const ExtraAdminList = () => {
  const dispatch = useDispatch();
  const extraAdmins = useSelector((state) => state.extraAdmin);
  
  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedExtraAdmin, setSelectedExtraAdmin] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const totalCount = extraAdmins?.getAllExtraAdmin?.data?.data?.length || 0;

  const handleAddModalClose = () => setShow(false);
  const handleAddModalOpen = () => setShow(true);

  const handleUpdateModalClose = () => {
    setUpdateModal(false);
    setSelectedExtraAdmin(null);
  };

  const handleUpdateModalOpen = (extraAdmin) => {
    setSelectedExtraAdmin(extraAdmin);
    setUpdateModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setSelectedExtraAdmin(null);
  };

  const handleDeleteModalOpen = (extraAdmin) => {
    setSelectedExtraAdmin(extraAdmin);
    setDeleteModal(true);
  };

  const initialValues = {
    name: '',
    email: '',
    phoneNumber: '',
    password: ''
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    phoneNumber: Yup.string().required('Phone number is required'),
    password: Yup.string().required('Password is required')
  });

  useEffect(() => {
    dispatch(getAllExtraAdmin());
  }, [dispatch]);

  const handleSubmit = (values, { resetForm }) => {
    dispatch(addExtraAdmin(values)).then(() => {
      resetForm();
      handleAddModalClose();
      dispatch(getAllExtraAdmin());
    });
  };

  const handleUpdate = (values) => {
    if (selectedExtraAdmin) {
      dispatch(updateExtraAdmin(selectedExtraAdmin._id, values)).then(() => {
        handleUpdateModalClose();
        dispatch(getAllExtraAdmin());
      });
    }
  };

  const handleDelete = () => {
    if (selectedExtraAdmin) {
      dispatch(deleteExtraAdmin(selectedExtraAdmin._id)).then(() => {
        handleDeleteModalClose();
        dispatch(getAllExtraAdmin());
      });
    }
  };

  // const handleSearch = (e) => {
  //   setSearchQuery(e.target.value);
  // };

  const renderFormFields = ({ handleSubmit, setFieldValue, values, handleClose }) => (
    <Form onSubmit={handleSubmit}>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={values.name}
                onChange={(e) => setFieldValue('name', e.target.value)}
                placeholder="Enter name"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage name="name" component="div" className="text-danger" />
            </Form.Group>
          </div>
          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={values.email}
                onChange={(e) => setFieldValue('email', e.target.value)}
                placeholder="Enter email"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage name="email" component="div" className="text-danger" />
            </Form.Group>
          </div>
          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                name="phoneNumber"
                value={values.phoneNumber}
                onChange={(e) => setFieldValue('phoneNumber', e.target.value)}
                placeholder="Enter phone number"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage name="phoneNumber" component="div" className="text-danger" />
            </Form.Group>
          </div>
          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="text"
                name="password"
                value={values.password}
                onChange={(e) => setFieldValue('password', e.target.value)}
                placeholder="Enter password"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage name="password" component="div" className="text-danger" />
            </Form.Group>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
          className="px-4 bg-transparent border-[1px] text-black border-green-color"
        >
          Close
        </Button>
        <Button
          type="submit"
          className="!bg-theme-dark border-0 px-4"
        >
          {selectedExtraAdmin ? 'Update' : 'Add'}
        </Button>
      </Modal.Footer>
    </Form>
  );

  return (
    <>
      <div className="mt-[100px] d-flex justify-content-between">
        <div className="d-flex items-center gap-3">
          {/* <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
            <IoSearchOutline />
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearch}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div> */}
        </div>
        <Button
          onClick={handleAddModalOpen}
          className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
        >
          <IoMdAdd className="mt-1 gap-1" />
          Add Extra Admin
        </Button>
      </div>

      <div className="mt-[50px] mb-4">
        <div className='mb-3 flex items-center justify-between mt-5'>
          <div className='d-flex align-items-center gap-2'>
            <h3 className='fw-bold mb-0'>Extra Admins List</h3>
          </div>
          <div className='d-flex align-items-center gap-4'>
            <span className='bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm fw-bold'>
              Total : <span className="text-theme-dark">{totalCount}</span>
            </span>
          </div>
        </div>

        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Phone</Th>
                <Th className="text-end">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {extraAdmins?.getAllExtraAdmin?.data?.user && extraAdmins.getAllExtraAdmin.data?.user?.length > 0 ? (
                extraAdmins.getAllExtraAdmin.data?.user?.map((admin) => (
                  <Tr key={admin._id}>
                    <Td>{admin.name}</Td>
                    <Td>{admin.email}</Td>
                    <Td>{admin.phoneNumber}</Td>
                    <Td>
                      <div className="d-flex gap-3 justify-end">
                        <FaEdit
                          onClick={() => handleUpdateModalOpen(admin)}
                          className="cursor-pointer border-green-color fs-5 text-success"
                          title="update"
                        />
                        <MdDelete
                          onClick={() => handleDeleteModalOpen(admin)}
                          className="cursor-pointer border-green-color fs-5 text-danger"
                          title="delete"
                        />
                      </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={4} textAlign='center'>No Extra Admins Found</Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      {/* Add Modal */}
      <Modal show={show} onHide={handleAddModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Extra Admin</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) => renderFormFields({
            ...formikProps,
            handleClose: handleAddModalClose
          })}
        </Formik>
      </Modal>

      {/* Update Modal */}
      <Modal show={updateModal} onHide={handleUpdateModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Extra Admin</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            name: selectedExtraAdmin?.name || '',
            email: selectedExtraAdmin?.email || '',
            phoneNumber: selectedExtraAdmin?.phoneNumber || '',
            password: selectedExtraAdmin?.plainPassword || ''
          }}
          validationSchema={validationSchema}
          onSubmit={handleUpdate}
          enableReinitialize
        >
          {(formikProps) => renderFormFields({
            ...formikProps,
            handleClose: handleUpdateModalClose
          })}
        </Formik>
      </Modal>

      {/* Delete Modal */}
      <Modal show={deleteModal} onHide={handleDeleteModalClose}>
        <Modal.Body className='p-5'>
          <div>
            <PiWarningCircleBold className='text-7xl w-100 text-danger' />
          </div>
          <div className='text-center mt-4'>
            <h3>Are You Sure?</h3>
            <p className='text-md'>Do you really want to delete this extra admin?</p>
          </div>
          <div className='d-flex justify-content-center gap-3 mt-4'>
            <Button
              variant="secondary"
              onClick={handleDeleteModalClose}
              className="px-4 bg-transparent border-[1px] text-black border-green-color"
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDelete}
              className="px-4"
            >
              Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ExtraAdminList;